import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppConfigService } from '@sphere/platform';
import * as localforage from 'localforage';
import { MatButton } from '@angular/material/button';

enum CookieNoticeData {
    key = 'privacy-policy',
    value = 'accepted'
}

@Component({
    selector: 'sphere-cookie-notice',
    templateUrl: './cookie-notice.component.html',
    styleUrls: ['./cookie-notice.component.scss'],
    imports: [MatButton]
})
export class CookieNoticeComponent {
    private bottomSheetRef = inject<MatBottomSheetRef<CookieNoticeComponent>>(MatBottomSheetRef);
    private appConfigService = inject(AppConfigService);

    public privacyPolicyUrl: string;

    constructor() {
        this.privacyPolicyUrl = this.appConfigService.getPrivacyPolicyUrl();
    }

    accept(): void {
        localforage
            .setItem(CookieNoticeData.key, CookieNoticeData.value)
            .then(_ => {
                this.bottomSheetRef.dismiss();
            })
            .catch(err => {
                console.debug(`localForage error ${err}`);
            });
    }
}
